// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32pTP","content":"styles_content__1OUAX"};